import { useMemo, useState } from 'react';
import {
  filterAndSortingKeys,
  noSelectionKey,
} from '../../../../../utilities/filterAndSortingsUtil';
import { SORTING_KEYS } from '../../../../../constants/sortingKeys';
import { getAttr } from '../../../../../features/helpers/apiHelpers';
import { mapInvitationGroup } from './mapEntities';
import { comparators } from '../../../../../utilities/comparators';

const INITIAL_FILTER_STATE = {
  [filterAndSortingKeys.sortingKey]: SORTING_KEYS.TITLEALPHABETICAL,
  [filterAndSortingKeys.title]: noSelectionKey,
};

const createInvitationGroupFilter = (filter) => (invitationGroup) =>
  filter === noSelectionKey ||
  (getAttr(invitationGroup, 'name') &&
    getAttr(invitationGroup, 'name')
      .toLowerCase()
      .includes(filter.toLowerCase()));

export const useFilterAndSort = (items) => {
  const [titleFilter, setTitleFilter] = useState(null);
  const [showSearchBar, setShowSearchBar] = useState(false);
  const [filterAndSortingSelection, setFilterAndSortingSelection] = useState(
    INITIAL_FILTER_STATE,
  );

  const filteredAndSortedItems = useMemo(() => {
    if (!items) return [];

    const titleFilterKey =
      filterAndSortingSelection[filterAndSortingKeys.title];
    const sortingKey =
      filterAndSortingSelection[filterAndSortingKeys.sortingKey];

    const filteredGroups = items.filter(
      createInvitationGroupFilter(titleFilterKey),
    );
    const mappedItems = filteredGroups.map(mapInvitationGroup);

    const comparator = comparators.updateInvitationGroups[sortingKey];
    return mappedItems.sort(comparator);
  }, [items, filterAndSortingSelection]);

  function handleTitleFilterChange(value) {
    setTitleFilter(value);
    setFilterAndSortingSelection((prev) => ({
      ...prev,
      [filterAndSortingKeys.title]: value || noSelectionKey,
    }));
  }

  function toggleSearchBar() {
    setShowSearchBar((prev) => !prev);
    if (showSearchBar) {
      handleTitleFilterChange(null);
    }
  }

  return {
    titleFilter,
    showSearchBar,
    filteredAndSortedItems,
    handleTitleFilterChange,
    toggleSearchBar,
  };
};
